<div class="sp-width__full sp-row__space">
  <h2 class="sp-orders__header sp-color__primary sp-text__ellipsized">
    <mat-icon
      class="sp-color__primary sp-hidden__before-md sp-cursor__pointer sp-margin__right"
      (click)="onBackClick()">
      arrow_back </mat-icon
    >{{ 'PRODUCT_CATEGORY.TITLE' | translate }}
  </h2>
  <div>
    <button
      (click)="onAddClick()"
      mat-icon-button
      [matTooltip]="'PRODUCT_CATEGORY.ADD_CTA' | translate"
      class="sp-icon__button sp-icon__button-dark sp-margin__left">
      <mat-icon class="material-symbols-outlined"> add_circle </mat-icon>
    </button>

    <button
      (click)="refresh.emit()"
      mat-icon-button
      [matTooltip]="'GENERAL.REFRESH_CTA' | translate"
      class="sp-icon__button sp-icon__button-dark sp-margin__left">
      <mat-icon class="material-symbols-outlined"> refresh </mat-icon>
    </button>
  </div>
</div>
